'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isModel = isModel;
exports.markModel = markModel;
var IS_MODEL_SENTINEL = '@@__FW_MODULA_MODEL__@@';

function isModel(maybeModel) {
  return !!(maybeModel && maybeModel[IS_MODEL_SENTINEL]);
}

function markModel(model) {
  model[IS_MODEL_SENTINEL] = true;
}